import { Button, ButtonType } from '@resurs-internal/styx-react'
import React, { useEffect, useRef } from 'react'
import { TokenStream } from '../common/flowevents'
import { useQuery } from '../common/utils'
import styles from './Sign.module.scss'

// COMPLETE | CANCELLED
const doSign = (result, token, taskId) => {
  window.location.href = `${
    process.env.REACT_APP_CHECKPOINT_MOCK_PROXY_PATH
  }/mock/doSign?resursToken=${token}${
    taskId ? `&taskId=${taskId}` : ''
  }&result=${result}`
}

const doSignSignicat = (token, taskId) => {
  window.location.href = `${
    process.env.REACT_APP_CHECKPOINT_MOCK_PROXY_PATH
  }/mock/signToSignicat?resursToken=${token}${
    taskId ? `&taskId=${taskId}` : ''
  }`
}

const getApplicantType = taskId => {
  switch (+taskId) {
    case 1:
      return 'MAIN_APPLICANT'
    case 2:
      return 'CO_APPLICANT'
    default:
      return ''
  }
}

export const Sign = () => {
  const { resursToken: token, taskId, altUrl } = useQuery()
  const streamRef = useRef(null)

  const goTo = url => {
    streamRef.current?.close()
    window.location.href = url
  }

  const handleEvent = ({ type, object }) => {
    if (type === 'FLOW') {
      if (
        ['DIGITAL_AGREEMENT_SIGNING', 'SIGNING'].includes(
          object.currentTask?.taskType,
        )
      ) {
        console.log(`currentTask: ${object.currentTask?.taskType}`)
      } else {
        goTo(object.flowUrl)
      }
    }
  }

  useEffect(() => {
    streamRef.current = new TokenStream(
      process.env.REACT_APP_SIGNING_FLOW_PROXY_PATH,
      token,
      getApplicantType(taskId),
    ).onMessage(event => {
      handleEvent(event)
    })
    return () => streamRef.current?.close()
  }, [])

  return (
    <>
      <h1>Sign agreement</h1>
      <div className={styles.lineWrapper}>
        <Button
          id="successButtonId"
          fullWidth
          onClick={() => {
            streamRef.current?.close()
            doSign('COMPLETE', token, taskId)
          }}
        >
          Sign
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="failureButtonId"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => {
            streamRef.current?.close()
            doSign('CANCELLED', token, taskId)
          }}
        >
          Cancel
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        {altUrl ? (
          <Button
            id="altMockButtonId"
            fullWidth
            outline
            type={ButtonType.Secondary}
            onClick={() => {
              goTo(decodeURIComponent(altUrl))
            }}
          >
            Review
          </Button>
        ) : (
          token && (
            <Button
              id="signicatButtonId"
              fullWidth
              onClick={() => {
                streamRef.current?.close()
                doSignSignicat(token, taskId)
              }}
            >
              Use Signicat
            </Button>
          )
        )}
      </div>
    </>
  )
}
